import { render } from "./ItemsContainer.vue?vue&type=template&id=a7c04ffc&scoped=true"
import script from "./ItemsContainer.vue?vue&type=script&lang=js"
export * from "./ItemsContainer.vue?vue&type=script&lang=js"

import "./ItemsContainer.vue?vue&type=style&index=0&id=a7c04ffc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7c04ffc"]])

export default __exports__